import { render } from "./BulkActionsBar.vue?vue&type=template&id=127ca58d&scoped=true"
import script from "./BulkActionsBar.vue?vue&type=script&lang=js"
export * from "./BulkActionsBar.vue?vue&type=script&lang=js"

import "./BulkActionsBar.vue?vue&type=style&index=0&id=127ca58d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ca58d"]])

export default __exports__